import { useEffect, useState } from "react";
import { gsap } from "gsap";
import { useInView } from "react-intersection-observer";
import { useDispatch } from "react-redux";
import { connect } from "../redux/blockchain/blockchainActions";
import { fetchData } from "../redux/data/dataActions";
import { useSelector } from "react-redux";

import useWindowDimensions from "../hooks/useWindowDimensions";
import logo from "../assets/logo.png";
import { Link } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";

const Navbar = () => {
  const { width } = useWindowDimensions();

  const [animated, setAnimated] = useState(false);
  const [ref, inView] = useInView();

  const dispatch = useDispatch();
  const blockchain = useSelector((state) => state.blockchain);
  const [isLoading, setLoading] = useState(false);
  const [isConnected, setConnected] = useState(false);
  const [connectBtnText, setConnectBtnText] = useState("Connect Wallet");

  const toastMessage = (message) => toast(message);

  useEffect(() => {
    if (inView && !animated) {
      let tl = gsap.timeline();

      tl.from(".navbar-brand", {
        stagger: 0.1,
        opacity: 0,
        delay: 0.2,
      });

      tl.from(".nav-item", {
        stagger: 0.1,
        opacity: 0,
      });

      setAnimated(!animated);
    }
  }, [inView]);

  const handleConnect = (e) => {
    e.preventDefault();
    if (blockchain.account === null) {
      setLoading(true);
      !isConnected && setConnectBtnText("Connecting...");
      dispatch(connect()).then((response) => {
        if (response !== undefined) {
          setConnected(false);
          setLoading(false);
          setConnectBtnText("Connect Wallet");
          toastMessage(response.payload);
        }
      });
      getData();
    }
  };

  const getData = () => {
    if (blockchain.account !== "" && blockchain.smartContract !== null) {
      dispatch(fetchData(blockchain.account));
      setConnected(true);
      setConnectBtnText("Connected");
      setLoading(false);
    }
  };

  useEffect(() => {
    getData();
  }, [blockchain.account]);

  return (
    <nav
      ref={ref}
      class="navbar navbar-light navbar-expand-md bg-faded justify-content-center px-3"
      style={{
        backdropFilter: "blur(3px)",
        backgroundImage:
          "linear-gradient(to top, rgba(0, 0, 0, 0), rgba(var(--dark-rgb), 1))",
      }}
    >
      <ToastContainer
        position="top-center"
        autoClose={5000}
        hideProgressBar
        newestOnTop
        closeOnClick
        theme="dark"
        toastStyle={{
          top: 10,
          backgroundColor: "var(--bg)",
          border: "1px solid var(--primary)",
          marginBottom: 10,
          borderRadius: 5,
          textAlign: "center",
          fontSize: 14,
        }}
        rtl={false}
        draggable
        pauseOnHover
      />
      <div class="container">
        <a href="/" class="navbar-brand d-flex w-50 me-auto">
          {width > 992 && (
            <div class="light-container">
              <div class="light" />
            </div>
          )}
          <img
            src={logo}
            className="navbar-logo"
            style={{
              width: width > 992 ? "30%" : "45%",
              cursor: "pointer",
            }}
          />
        </a>
        <button
          class="navbar-toggler shadow-none ms-auto"
          style={{
            border: "none",
            outline: "none",
          }}
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbar"
        >
          <i
            class="bi bi-list"
            style={{
              color: "var(--primary)",
              cursor: "pointer",
              fontSize: 32,
            }}
          ></i>
        </button>
        <div class="navbar-collapse collapse w-100" id="navbar">
          <ul class="nav navbar-nav ms-auto w-100 justify-content-end">
            <li class="nav-item">
              <Link class="nav-link" to="/purchase">
                Purchase
              </Link>
            </li>
            <li class="nav-item">
              <a class="nav-link" href="/#utilities">
                Utility
              </a>
            </li>
            <li class="nav-item">
              <a class="nav-link" href="/#roadmap">
                Roadmap
              </a>
            </li>
            <li class="nav-item">
              <a class="nav-link" href="/#collectibles">
                Collectibles
              </a>
            </li>
            <li class="nav-item dropdown">
              <a
                class="nav-link"
                id="members-dropdown"
                role="button"
                data-bs-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
              >
                Members
                <i
                  class="bi bi-chevron-down"
                  style={{
                    cursor: "pointer",
                    color: "var(--primary)",
                    marginLeft: 5,
                    fontSize: 12,
                    fontWeight: 700,
                  }}
                ></i>
              </a>
              <div
                class="dropdown-menu dropdown-menu-right"
                aria-labelledby="members-dropdown"
              >
                <a class="dropdown-item" href="/#ecolocation-reward">
                  Ecolocation Reward
                </a>
                <a class="dropdown-item" href="/">
                  Private Planet
                </a>
                <a class="dropdown-item" href="/">
                  Villa Editor
                </a>
                <a class="dropdown-item" href="/">
                  Merch
                </a>
              </div>
            </li>
            <li className="nav-item">
              <button
                id="home-btn"
                className="primary-btn"
                onClick={handleConnect}
                disabled={isLoading || isConnected}
                style={{
                  fontSize: 16,
                  padding: "5px 8px 8px 10px",
                  marginLeft: 10,
                }}
              >
                {connectBtnText}
              </button>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
